import { useDispatch as useDispatchInternal } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { StoreStateType } from 'index'

type DispatchType = ThunkDispatch<StoreStateType, void, AnyAction>

export const useDispatch = () => {
  const dispatch: DispatchType = useDispatchInternal()

  return dispatch
}
